"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaylistEntity = exports.ProgrammaticMediaPlaylistEntity = exports.MediaPlaylistEntity = void 0;
const media_1 = require("../media");
class MediaPlaylistEntity extends media_1.MediaEntity {
    block;
    isLastMedia;
    mediaCampaignId;
    /** Capture proof even when campaign and display belong to the same owner. */
    forceScreenshots;
    playlistId;
    // Esta duracion es el resultado de la duracion del media expresado en bloques
    identifier;
    mediaDuration;
    hours;
    objectFit;
    slotType;
    ownerSlotIndex;
    loopKey;
    /** One slot with ordered alternatives, not several adjacent playlist entries. */
    creativeRotation;
    /** Assigned by the server to a concrete occurrence, never derived from global sequence. */
    creativeOccurrence;
}
exports.MediaPlaylistEntity = MediaPlaylistEntity;
/** Online-only playback item. It is never persisted in a canonical playlist or offline plan. */
class ProgrammaticMediaPlaylistEntity extends media_1.MediaEntity {
    isLastMedia;
    playlistId;
    identifier;
    mediaDuration;
    hours;
    objectFit;
    slotType;
    mediaCampaignId;
    forceScreenshots;
    ownerSlotIndex;
    programmaticDeliveryId;
    programmaticExpiresAt;
    loopKey;
}
exports.ProgrammaticMediaPlaylistEntity = ProgrammaticMediaPlaylistEntity;
class PlaylistEntity {
    _id;
    id;
    medias;
    is_on;
    is_archive;
    date;
    display;
    updatedAt;
    createdAt;
}
exports.PlaylistEntity = PlaylistEntity;
